import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Toast,
  Userlogin,
  ownerDrop,
  DateFormate,
  customStyles,
  PushpoptoCatalogue,
  priceTagCmn,
} from "./Utils/general-function";
import Header from "./Header";
import Upload_photo from "./Uploadimage/Upload-Photo";
import DatePicker from "react-widgets/DatePicker";
import "react-widgets/styles.css";
import { parse } from "date-fns";
import { Helmet } from "react-helmet";
import Loader from "./Utils/Loader";
import Select from "react-select";
import styled from "styled-components";
import { Modal } from "react-bootstrap";
import Resizer from "react-image-file-resizer";

export const Span = styled.span`
  font-size: 13px;
  color: #686868;
  letter-spacing: 0.5px;
`;
const Star = styled.span`
  color: #ff1237;
  margin-left: 2px;
`;
function CarInquiry(props) {
  const [loading, setLoading] = useState(true);
  const [Companylist, setCompanylist] = useState([]);
  const [vehicletypes, setVehicletypes] = useState([]);
  const [Brandlist, setBrandlist] = useState([]);
  const [Varientlist, setVarientlist] = useState([]);
  const [Colorlist, setColorlist] = useState([]);
  const [Fuelist, setFuelist] = useState([]);
  const [Gearlist, setGearlist] = useState([]);
  const [input, setInput] = useState({
    stardate: DateFormate(new Date()),
    enddate: DateFormate(new Date()),
    gear: "",
    owner: "",
    seatingcapicity: "",
    year: "",
    km: "",
    nInsurancetype: "Comprehensive",
    color: "",
    sunroof: "No",
    cc: "",
    nSaleprice: "",
    nPurchaseprice: "",
    vehicle: "",
    priceTag: priceTagCmn[0].Value,
  });
  const [check, setCheck] = useState("Nill");
  const [carstatus, setCarstatus] = useState("No");
  const [src, setSrc] = useState("");
  const [Features, setFeatures] = useState([]);
  const [SelectedFeatures, setSelectedFeatures] = useState([]);
  const [errors, setErrors] = useState({});
  const [addPhotoMdlShow, setAddPhotoMdlShow] = useState(false);
  const [addedCarData, setAddedCarData] = useState({
    carId: null,
    carNumber: null,
  });
  const selectRef = useRef({});
  const navigate = useNavigate();
  const nextMoveRef = useRef([]);

  useEffect(() => {
    let mounted = true;
    let model;
    if (Userlogin()) {
      fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/companydata")
        .then((response) => response.json())
        .then((res) => {
          if (mounted) {
            setCompanylist(res.Data);
          }
        });
      fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/Fueldata")
        .then((response) => response.json())
        .then((res) => {
          if (mounted) {
            setFuelist(res.Data);
          }
        });
      fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/Geardata")
        .then((response) => response.json())
        .then((res) => {
          if (mounted) {
            setGearlist(res.Data);
          }
        });
      fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/Vehiclenamedata")
        .then((response) => response.json())
        .then((res) => {
          if (mounted) {
            setVehicletypes(res.Data);
          }
        });

      fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/Featuresdata")
        .then((response) => response.json())
        .then((res) => {
          if (mounted) {
            var option = [];
            var obj;
            res.Data.map((data) => {
              obj = {
                label: data.Text,
                value: data.Value,
              };
              option.push(obj);
              return option;
            });
            setFeatures(option);
          }
        });

      setLoading(false);
    } else {
      navigate("/Login");
    }
    return () => {
      mounted = false;
      if (model) {
        model.dispose();
      }
    };
  }, [navigate]);

  const handleCompanychange = (obj) => {
    fetch(
      process.env.REACT_APP_API_ENDPOINT +
        "/api/Common/activemodel/" +
        obj.Value,
    )
      .then((response) => response.json())
      .then((res) => {
        setBrandlist(res.Data || []);
        setVarientlist([]);
        setColorlist([]);
        setInput((prevInput) => ({
          ...prevInput,
          company: obj.Value,
          Model: "",
          color: "",
          varient: "",
        }));
      });
  };

  const handleModalchange = (obj) => {
    var details =
      "companyid=" +
      encodeURIComponent(input.company) +
      "&Modelid=" +
      encodeURIComponent(obj.Value);
    const requestOptions = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      body: details,
    };
    fetch(
      process.env.REACT_APP_API_ENDPOINT + "/api/Common/veriantandcolour",
      requestOptions,
    )
      .then((response) => response.json())
      .then((res) => {
        setVarientlist(res.Data.veriantdata || []);
        setColorlist(res.Data.Colourdata || []);
        setInput((prevInput) => ({
          ...prevInput,
          Model: obj,
          varient: "",
          color: "",
        }));
      });
  };

  const handlevarient = (obj) => {
    setInput((prevInput) => ({
      ...prevInput,
      varient: obj.Value,
      color: "",
    }));
  };
  const handleChange = (e, index) => {
    const isCarNumber = e.target.name === "carnumber";
    // const isVarient = e.target.name === "varient";
    // const isColor = e.target.name === "color";
    let value = e.target.value;
    setInput((prevInput) => ({
      ...prevInput,
      [e.target.name]: isCarNumber ? value.toUpperCase() : value,
      // color: isVarient ? "" : isColor ? value : prevInput.color,
    }));
  };

  const ondropdown = (opt) => {
    setSelectedFeatures(opt);
  };

  const HandleNumerictextbox = (e) => {
    var pattern = new RegExp(/^[0-9\b]+$/);
    const { name, value } = e.target;
    if (value === "" || pattern.test(value)) {
      setInput((prevInput) => ({ ...prevInput, [name]: value }));
    }
  };

  const HandleAmtInput = (e) => {
    // only for rupees
    const raw = e.target.value.replace(/[^0-9]/g, ""); // Remove non-digits
    const { name } = e.target;
    setInput((prevInput) => ({ ...prevInput, [name]: raw }));
  };

  const onDatechange = (value, name) => {
    setInput((prevInput) => ({
      ...prevInput,
      [name]: DateFormate(value),
    }));
  };

  const oncheck = (e) => {
    const target = e.target;
    setCheck(target.checked ? "Yes" : "Nill");
  };

  const onstatuscheck = (e) => {
    const target = e.target;
    setCarstatus(target.checked ? "Yes" : "No");
  };

  //
  // utils/vehicleValidation.js

  const INDIAN_STATE_CODES = [
    "AN",
    "AP",
    "AR",
    "AS",
    "BR",
    "CH",
    "CG",
    "DD",
    "DL",
    "DN",
    "GA",
    "GJ",
    "HP",
    "HR",
    "JH",
    "JK",
    "KA",
    "KL",
    "LA",
    "LD",
    "MH",
    "ML",
    "MN",
    "MP",
    "MZ",
    "NL",
    "OD",
    "PB",
    "PY",
    "RJ",
    "SK",
    "TN",
    "TR",
    "TS",
    "UK",
    "UP",
    "WB",
  ];

  const validateVehicleNumber = (value) => {
    if (!value || typeof value !== "string") {
      return false;
    }

    // Remove spaces and hyphens; convert to uppercase
    const number = value.replace(/[\s-]/g, "").toUpperCase();

    // Bharat (BH) series: YYBH####XX
    const bhPattern = /^\d{2}BH\d{4}[A-HJ-NP-Z]{1,2}$/;

    if (bhPattern.test(number)) {
      return true;
    }

    // Regular state / UT registration
    const regularPattern = /^([A-Z]{2})(\d{1,2})([A-Z]{0,3})(\d{1,4})$/;

    const match = number.match(regularPattern);

    if (!match) {
      return false;
    }

    const [, stateCode, rtoCode, series, digits] = match;

    // Validate state / UT code
    if (!INDIAN_STATE_CODES.includes(stateCode)) {
      return false;
    }

    // RTO code must be between 1 and 99
    const rtoNumber = Number(rtoCode);

    if (rtoNumber < 1 || rtoNumber > 99) {
      return false;
    }

    // Registration number must not be zero
    if (Number(digits) === 0) {
      return false;
    }

    return true;
  };
  // end
  const Validate = () => {
    let errors = {};
    let isValid = true;

    if (!input["vehicle"]) {
      isValid = false;
      errors["vehicle"] = "This feild is required";
    }
    if (!input["company"]) {
      isValid = false;
      errors["company"] = "This feild is required";
    }
    if (!input["Model"]) {
      isValid = false;
      errors["Model"] = "This feild is required";
    }
    if (!input["varient"]) {
      isValid = false;
      errors["varient"] = "This feild is required";
    }
    if (!input["color"]) {
      isValid = false;
      errors["color"] = "This feild is required";
    }
    if (!input["fuel"]) {
      isValid = false;
      errors["fuel"] = "This feild is required";
    }
    if (!input["carnumber"]) {
      isValid = false;
      errors["carnumber"] = "This feild is required.";
    }
    if (typeof input["carnumber"] !== "undefined") {
      var pattern = new RegExp(process.env.REACT_APP_CARNO_PATTERN);
      if (!validateVehicleNumber(input["carnumber"])) {
        isValid = false;
        errors["carnumber"] = "Enter valid vehicle number";
      }
    }
    if (!input["year"]) {
      isValid = false;
      errors["year"] = "This feild is  required";
    }
    if (typeof input["year"] !== undefined) {
      if (input["year"].length > 4) {
        isValid = false;
        errors["year"] = "Enter valid Year";
      }
    }
    // if (!input["km"]) {
    //   isValid = false;
    //   errors["km"] = "This feild is required";
    // }
    if (String(input["km"]).trim() !== "") {
      if (input["km"].length > 6) {
        isValid = false;
        errors["km"] = "Enter valid kilometer";
      }
    }
    if (!input["owner"]) {
      isValid = false;
      errors["owner"] = "This feild is required";
    }
    if (!input["seatingcapicity"]) {
      isValid = false;
      errors["seatingcapicity"] = "This feild is required";
    }
    if (typeof input["seatingcapicity"] !== undefined) {
      if (Number(input["seatingcapicity"]) > 15) {
        isValid = false;
        errors["seatingcapicity"] = "Maximum seating capacity is 15";
      }
    }
    if (!input["gear"]) {
      isValid = false;
      errors["gear"] = "This feild is required";
    }
    if (!input["cc"]) {
      isValid = false;
      errors["cc"] = "This feild is required";
    }
    if (input["cc"]) {
      if (input["cc"].length > 4) {
        isValid = false;
        errors["cc"] = "Enter valid cubic capacity";
      }
    }
    if (input["insurance"] === true) {
      if (!input["enddate"]) {
        isValid = false;
        errors["enddate"] = "This feild  is required ";
      }
    }
    if (!input["photo"]) {
      isValid = false;
      errors["photo"] = "Vehicle photo is required";
    }

    FocusonField(errors);
    setErrors(errors);
    return isValid;
  };

  const FocusonField = (errors) => {
    if (Object.keys(errors).length > 0) {
      // Scroll to the first error field
      let errorElement;
      const firstErrorField = Object.keys(errors)[0];
      if (selectRef.current[firstErrorField]) {
        errorElement = selectRef.current[firstErrorField].controlRef;
      } else {
        errorElement = document.getElementsByName(firstErrorField)[0];
      }
      // errorElement = selectRef.current.controlRef;

      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
        errorElement.focus();
      }
    }
  };
  const handleSubmit = () => {
    if (Validate()) {
      setLoading(true);
      var param = {
        carnumber: input.carnumber.trim(),
        companyid: input.company,
        carmodelid: input.Model.Value,
        variantid: input.varient,
        fueltypeid: input.fuel,
        modelyear: input.year,
        colour: input.color,
        insurance: check,
        insuranceendtdate: check === "Yes" ? input.enddate : "",
        km: input.km.trim(),
        owner: input.owner,
        seatingcapicity: input.seatingcapicity.trim(),
        Photoname: input.Photoname,
        carphoto: input.photo,
        gear: input.gear,
        nInsurancetype: check === "Yes" ? input.nInsurancetype : "",
        nSunRoof: input.sunroof,
        nCc: input.cc.trim(),
        nSaleprice: input.nSaleprice.trim(),
        nPurchaseprice: input.nPurchaseprice.trim(),
        nCaravaibility: carstatus,
        vehicleid: input.vehicle,
        nFeatures:
          SelectedFeatures.length !== 0
            ? SelectedFeatures.map((item) => item.value).join(",")
            : "",
        npricerate: input.priceTag,
      };

      var formBody = [];
      for (var property in param) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(param[property]);
        formBody.push(encodedKey + "=" + encodedValue);
      }
      formBody = formBody.join("&");
      const requestOptions = {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
        },
        body: formBody,
      };
      fetch(
        process.env.REACT_APP_API_ENDPOINT + "/api/Carmaster/addcar",
        requestOptions,
      )
        .then((response) => response.json())
        .then(async (res) => {
          setLoading(false);
          if (res.Success === true) {
            let catalogueAdded = await PushpoptoCatalogue(
              input.carnumber,
              res.Data,
              "add",
            );

            if (catalogueAdded?.Success) {
              setAddPhotoMdlShow(true);
              setAddedCarData({ carId: res.Data, carNumber: input.carnumber });
            } else {
              navigate("/MyCar");
            }

            // navigate("/MyCar");
            Toast(res.Success, "Vehicle added Successfully", res.Message);
          } else {
            Toast(res.Success, "", res.Message);
          }
        });
    }
  };

  const handleCallback = (childData) => {
    input["photo"] = childData.url.split(",")[1];
    input["Photoname"] = childData.name;
    setInput(input);
    setSrc(childData.url);
  };

  const nextMoveFn = ({ value, index }) => {
    // use: move next dropdodwn on select value of currenct dropdown
    if (
      String(value).length > 0 &&
      index >= 0 &&
      index < nextMoveRef.current.length - 1
    ) {
      let nextElm = nextMoveRef.current[index + 1];
      if (!nextElm) return;

      nextElm.focus();

      let eleRef = nextElm.controlRef ?? nextElm; // controlRef for react-select dropdown

      eleRef.scrollIntoView({
        behavior: "smooth",
        block: "center", // Ensures it's visible in the viewport
        inline: "nearest",
      });
    }
  };

  // new
  // for uploading car more images through api
  const uploadMoreImages = (childData) => {
    setLoading(true);
    const param = {
      carid: addedCarData.carId,
      carnumber: addedCarData.carNumber,
      imageslist: JSON.stringify(childData),
    };
    var formBody = [];
    for (var property in param) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(param[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    const requestOptions = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
      },
      body: formBody,
    };
    fetch(
      process.env.REACT_APP_API_ENDPOINT + "/api/CarCateloge/addcarcateloge",
      requestOptions,
    )
      .then((response) => response.json())
      .then((res) => {
        setLoading(false);
        navigate("/MyCar");
      });
  };

  const handleFileChange = (e) => {
    // handle input of car more images
    setLoading(true);
    const files = Array.from(e.target.files); // Convert FileList to array
    if (files.length > 20) {
      Toast(false, "", "20-photo limit; unable to upload more.");
      setLoading(false);
      return;
    }

    Promise.all(
      files.map((file) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
              const aspectRatio = img.width / img.height;
              const fixedWidth = 700;
              const fixedHeight = fixedWidth / aspectRatio;

              Resizer.imageFileResizer(
                file,
                fixedWidth,
                fixedHeight,
                "JPEG",
                75,
                0,
                (resizedFile) => {
                  resolve({ url: resizedFile, name: file.name });
                },
                "base64",
                fixedWidth,
                fixedHeight,
              );
            };
            img.src = event.target.result;
          };
          reader.readAsDataURL(file);
        });
      }),
    ).then((resizedImages) => {
      uploadMoreImages(resizedImages);
    });
  };
  // new end
  console.log("input", input);

  return (
    <div>
      <Header />
      {loading ? <Loader /> : null}

      <div className="content">
        <div className="text-center">
          <h2 className="page-title">Add Car</h2>
        </div>

        <div className="form-div">
          <label className="form-label">
            Vehicle Type<Star>*</Star>
          </label>
          <select
            className="form-select form-control"
            name="vehicle"
            ref={(el) => (nextMoveRef.current[0] = el)}
            value={input.vehicle}
            onChange={(e) => {
              handleChange(e);
              nextMoveFn({ value: e.target.value, index: 0 });
            }}
          >
            <option value="" disable="disable">
              --Select vehicle Type--
            </option>
            {vehicletypes.map((list) => (
              <option value={list.Value} key={list.Value}>
                {list.Text}
              </option>
            ))}
          </select>

          <span className="text-danger">{errors.vehicle}</span>
        </div>

        <div className="form-div">
          <label className="form-label">
            Company<Star>*</Star>
          </label>
          <Select
            ref={(el) => {
              if (el) {
                selectRef.current.company = el;
                nextMoveRef.current[1] = el; // for move next on select automatically
              }
            }}
            placeholder="--Select Company--"
            name="company"
            options={Companylist}
            // value={}
            getOptionLabel={(option) => option.Text}
            getOptionValue={(option) => option.Value}
            onChange={(e) => {
              handleCompanychange(e);

              nextMoveFn({ value: e.Value, index: 1 });
            }}
            closeMenuOnSelect={true}
            blurInputOnSelect={false}
            isSearchable={true}
            styles={customStyles}
          ></Select>

          <span className="text-danger">{errors.company}</span>
        </div>

        <div className="form-div">
          <label className="form-label">
            Model<Star>*</Star>
          </label>
          <Select
            placeholder="--Select Model--"
            value={input.Model}
            name="Model"
            ref={(el) => {
              if (el) {
                selectRef.current.Model = el;
                nextMoveRef.current[2] = el;
              }
            }}
            options={Brandlist}
            getOptionLabel={(option) => option.Text}
            getOptionValue={(option) => option.Value}
            onChange={(e) => {
              handleModalchange(e);

              nextMoveFn({ value: e.Value, index: 2 });
            }}
            closeMenuOnSelect={true}
            blurInputOnSelect={false}
            isSearchable={true}
            styles={customStyles}
          ></Select>
          <span className="text-danger">{errors.Model}</span>
        </div>

        <div className="form-div">
          <label className="form-label">
            Varient<Star>*</Star>
          </label>
          <Select
            placeholder="--Select Varient--"
            name="varient"
            // value={}
            ref={(el) => {
              if (el) {
                selectRef.current.varient = el;
                nextMoveRef.current[3] = el;
              }
            }}
            options={Varientlist}
            getOptionLabel={(option) => option.Text}
            getOptionValue={(option) => option.Value}
            onChange={(e) => {
              handlevarient(e);
              nextMoveFn({ value: e.Value, index: 3 });
            }}
            closeMenuOnSelect={true}
            blurInputOnSelect={false}
            isSearchable={true}
            styles={customStyles}
          ></Select>
          <span className="text-danger">{errors.varient}</span>
        </div>

        <div className="form-div">
          <label className="form-label">
            Color<Star>*</Star>
          </label>
          {/* <select
            className="form-select form-control"
            ref={(el) => {
              if (el) {
                nextMoveRef.current[4] = el;
              }
            }}
            name="color"
            value={input.color}
            onChange={(e) => {
              handleChange(e);
              nextMoveFn({ value: e.target.value, index: 4 });
            }}
          >
            <option value="" disable="disable">
              --Select Color--
            </option>
            {Colorlist.map((list) => (
              <option value={list.Value} key={list.Value}>
                {list.Text}
              </option>
            ))}
          </select> */}
          <Select
            placeholder="--Select Color--"
            value={(Colorlist || []).find((d) => d.Value === input.color)}
            name="color"
            ref={(el) => {
              if (el) {
                nextMoveRef.current[4] = el;
              }
            }}
            options={Colorlist}
            getOptionLabel={(option) => option.Text}
            getOptionValue={(option) => option.Value}
            onChange={(e) => {
              setInput((prevInput) => ({
                ...prevInput,
                color: e?.Value,
              }));
              nextMoveFn({ value: e?.Value, index: 4 });
            }}
            closeMenuOnSelect={true}
            blurInputOnSelect={false}
            isSearchable={true}
            // isClearable
            styles={customStyles}
          ></Select>

          <span className="text-danger">{errors.color}</span>
        </div>

        <div className="form-div">
          <label className="form-label">
            Fuel<Star>*</Star>
          </label>

          <Select
            placeholder="--Select Fuel--"
            value={(Fuelist || []).find((d) => d.Value === input.fuel)}
            name="fuel"
            ref={(el) => {
              if (el) {
                nextMoveRef.current[5] = el;
              }
            }}
            options={Fuelist}
            getOptionLabel={(option) => option.Text}
            getOptionValue={(option) => option.Value}
            onChange={(e) => {
              setInput((prevInput) => ({
                ...prevInput,
                fuel: e?.Value,
              }));
              nextMoveFn({ value: e?.Value, index: 5 });
            }}
            closeMenuOnSelect={true}
            blurInputOnSelect={false}
            isSearchable={true}
            styles={customStyles}
          ></Select>

          <span className="text-danger">{errors.fuel}</span>
        </div>

        <div className="form-div">
          <label className="form-label">
            Vehicle number<Star>*</Star> <Span>(Ex. GJ01HQ9999)</Span>
          </label>
          <input
            type="text"
            className="form-control"
            name="carnumber"
            id="carnumber"
            value={input.carnumber}
            onChange={handleChange}
            ref={(el) => {
              if (el) {
                nextMoveRef.current[6] = el;
              }
            }}
          />
          <span className="text-danger">{errors.carnumber}</span>
        </div>

        <div className="form-div">
          <label className="form-label">
            Year<Star>*</Star>
          </label>
          <input
            type="number"
            className="form-control"
            name="year"
            value={input.year}
            maxLength="4"
            onChange={HandleNumerictextbox}
          />
          <span className="text-danger">{errors.year}</span>
        </div>

        <div className="form-div">
          <label className="form-label">
            Kilometer
            {/* Kilometer<Star>*</Star> */}
          </label>
          <input
            type="tel"
            className="form-control"
            name="km"
            // maxLength="7"
            // value={input.km}
            value={input.km ? Intl.NumberFormat("en-IN").format(input.km) : ""}
            // onChange={HandleNumerictextbox}
            onChange={HandleAmtInput}
          />
          <span className="text-danger">{errors.km}</span>
        </div>

        <div className="form-div">
          <label className="form-label">
            Vehicle owner<Star>*</Star>
          </label>
          <select
            className="form-select form-control"
            name="owner"
            defaultValue=""
            onChange={handleChange}
          >
            <option value="" disable="disable">
              --Select owner--
            </option>
            {ownerDrop.map((list) => (
              <option value={list.Value} key={list.Value}>
                {list.Text}
              </option>
            ))}
          </select>

          <span className="text-danger">{errors.owner}</span>
        </div>

        <div className="form-div">
          <label className="form-label">
            Seating capacity<Star>*</Star>
          </label>
          <input
            type="number"
            className="form-control"
            name="seatingcapicity"
            max="2"
            value={input.seatingcapicity}
            onChange={HandleNumerictextbox}
          />
          <span className="text-danger">{errors.seatingcapicity}</span>
        </div>

        <div className="form-div">
          <label className="form-label">
            Gear<Star>*</Star>
          </label>
          <select
            className="form-select form-control"
            name="gear"
            defaultValue=""
            ref={(el) => {
              if (el) {
                nextMoveRef.current[7] = el;
              }
            }}
            onChange={(e) => {
              handleChange(e);

              nextMoveFn({ value: e.target.value, index: 7 });
            }}
          >
            <option value="" disable="disable">
              --Select Gear--
            </option>
            {Gearlist.map((list) => (
              <option value={list.Value} key={list.Value}>
                {list.Text}
              </option>
            ))}
          </select>

          <span className="text-danger">{errors.gear}</span>
        </div>

        <div className="form-div">
          <label className="form-label">
            Sunroof<Star>*</Star>
          </label>
          <select
            className="form-select form-control"
            name="sunroof"
            defaultValue="No"
            ref={(el) => {
              if (el) {
                nextMoveRef.current[8] = el;
              }
            }}
            onChange={(e) => {
              handleChange(e);

              nextMoveFn({ value: e.target.value, index: 8 });
            }}
          >
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>

        <div className="form-div">
          <label className="form-label">
            Choose a vehicle feature <Span>(optional)</Span>
          </label>
          <Select
            ref={(el) => {
              if (el) {
                nextMoveRef.current[9] = el;
              }
            }}
            isMulti
            name="feature"
            options={Features}
            onChange={ondropdown}
            closeMenuOnSelect={false}
            blurInputOnSelect={false}
            isSearchable={false}
            styles={customStyles}
          ></Select>
        </div>

        <div className="form-div">
          <label className="form-label">
            Cubic capacity<Star>*</Star> <Span>(Ex. 1.6)</Span>
          </label>
          <input
            type="number"
            step="0.01"
            className="form-control"
            name="cc"
            value={input.cc}
            maxLength="4"
            onChange={handleChange}
          />
          <span className="text-danger">{errors.cc}</span>
        </div>

        <div className="form-div">
          <label className="form-label">
            Sale price for salesman <Span>(optional)</Span>
          </label>
          <input
            type="tel"
            className="form-control"
            name="nPurchaseprice"
            // value={input.nPurchaseprice}
            value={
              input.nPurchaseprice
                ? Intl.NumberFormat("en-IN").format(input.nPurchaseprice)
                : ""
            }
            maxLength="13" // 10 digit with comma
            onChange={HandleAmtInput}
          />
          <span className="text-danger">{errors.nPurchaseprice}</span>
        </div>

        <div className="form-div">
          <label className="form-label">
            Sale price for customer <Span>(optional)</Span>
          </label>
          <input
            type="tel"
            className="form-control"
            name="nSaleprice"
            // value={input.nSaleprice}
            value={
              input.nSaleprice
                ? Intl.NumberFormat("en-IN").format(input.nSaleprice)
                : ""
            }
            maxLength="13" // 10 digit with comma
            onChange={HandleAmtInput}
          />
          <span className="text-danger">{errors.nSaleprice}</span>
        </div>

        {/* new added */}
        <div className="form-div">
          <label className="form-label">Price Tag</label>
          <select
            className="form-select form-control"
            name="priceTag"
            onChange={(e) => {
              handleChange(e);
            }}
            value={input?.priceTag}
          >
            <option value="" disabled>
              --Select Price Tag--
            </option>
            {priceTagCmn.map((list) => (
              <option value={list.Value} key={list.Value}>
                {list.Text}
              </option>
            ))}
          </select>
        </div>
        {/* new added end */}
        <div className="form-check-inline form-div">
          <input
            type="checkbox"
            className="form-check-input"
            id="check2"
            name="carstatus"
            onChange={onstatuscheck}
          />
          <label className="form-label ms-1" htmlFor="check2">
            Coming soon
            <div>
              <Span> (Check to create status- as 'Coming Soon')</Span>
            </div>
          </label>
        </div>
        <div>
          <div className="form-check-inline form-div">
            <input
              type="checkbox"
              className="form-check-input"
              id="check1"
              name="insurance"
              onChange={oncheck}
            />
            <label className="form-label ms-1" htmlFor="check1">
              Insurance
            </label>
          </div>
          {check === "Yes" ? (
            <div>
              <div className="text-center">
                <div className="form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="radio1"
                    name="nInsurancetype"
                    value="Comprehensive"
                    defaultChecked={
                      input.nInsurancetype === "Comprehensive" ? true : false
                    }
                    onChange={handleChange}
                  />
                  <label className="form-check-label ps-1" htmlFor="radio1">
                    Comprehensive
                  </label>
                </div>
                <div className="form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="radio2"
                    name="nInsurancetype"
                    value="Third Party"
                    defaultChecked={
                      input.nInsurancetype === "Third Party" ? true : false
                    }
                    onChange={handleChange}
                  />
                  <label className="form-check-label ps-1" htmlFor="radio2">
                    Third Party
                  </label>
                </div>
                <div className="form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="radio3"
                    name="nInsurancetype"
                    value="Zero depth"
                    defaultChecked={
                      input.nInsurancetype === "Zero depth" ? true : false
                    }
                    onChange={handleChange}
                  />
                  <label className="form-check-label ps-1" htmlFor="radio3">
                    Zero depth
                  </label>
                </div>
              </div>
              {/* <div className="form-div">
                <label className="form-label">Insurance Start Date</label>

                <DatePicker
                  defaultValue={new Date()}
                  valueFormat={{ dateStyle: "medium" }}
                  name="stardate"
                  onChange={(e) => onDatechange(e, "stardate")}
                  onKeyDown={(e) => e.preventDefault()}
                />

                <span className="text-danger">{errors.stardate}</span>
              </div> */}
              <div className="form-div">
                <label className="form-label">Insurance End Date</label>
                <DatePicker
                  defaultValue={new Date()}
                  valueFormat={{ dateStyle: "medium" }}
                  name="enddate"
                  onChange={(e) => onDatechange(e, "enddate")}
                  onKeyDown={(e) => e.preventDefault()}
                  inputProps={{ readOnly: true }}
                />
                <span className="text-danger">{errors.enddate}</span>
              </div>
            </div>
          ) : null}
        </div>
        <div className="form-div">
          <div className="mb-2 mx-1">
            <span style={{ fontWeight: "500", color: "#ff1237" }}>Note :</span>
            <span className="title" style={{ color: "#ff1237" }}>
              &nbsp; Only one front photo of vehicle can be added from here. HD
              and .HEIC photos are not allowed.
            </span>
          </div>
          <Upload_photo parentCallback={handleCallback} />

          <span className="text-danger">{errors.photo}</span>
          <div className="col-12 text-center pt-2">
            {src ? (
              <img src={src} style={{ maxWidth: "200px" }} alt="" />
            ) : (
              <>
                <span className="title" style={{ color: "#ff1237" }}>
                  For example :
                </span>
                <br />
                <img
                  src="/assets/images/add-vehicle-sample.jpg"
                  style={{ maxWidth: "200px" }}
                  alt=""
                />
              </>
            )}
          </div>
        </div>

        <div className="text-center pt-3">
          <button type="submit" className="submitbtn" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>

      {/* add car more image */}
      <Modal
        show={addPhotoMdlShow}
        onHide={(e) => {
          setAddPhotoMdlShow(false);
          navigate("/MyCar");
        }}
        id="resultpopup"
        className="modal"
      >
        <Modal.Header closeButton>
          <h4 className="modal-title">Add multiple photos</h4>
        </Modal.Header>
        <Modal.Body>
          {loading ? <Loader /> : null}

          <div className="text-center py-3">
            {/* <label htmlFor="image"> */}
            <input
              type="file"
              name="image"
              id="addmorephoto"
              accept=".jpg,.jpeg,.png"
              className="form-control d-none"
              onChange={handleFileChange}
              multiple
            />
            <label className="catlg-addimg" htmlFor="addmorephoto">
              <span className="mticon">
                <span className="material-symbols-outlined">add_a_photo</span>
              </span>{" "}
              Add Images
            </label>

            {/* <div className="text-danger">{maxerror}</div> */}

            {/* <CatimgUpload parentCallback={(data) => handleCallback(data)} /> */}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default CarInquiry;

// old without add more  photos popup on car add
// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Toast,
//   Userlogin,
//   ownerDrop,
//   DateFormate,
//   customStyles,
//   PushpoptoCatalogue,
//   priceTagCmn,
// } from "./Utils/general-function";
// import Header from "./Header";
// import Upload_photo from "./Uploadimage/Upload-Photo";
// import DatePicker from "react-widgets/DatePicker";
// import "react-widgets/styles.css";
// import { parse } from "date-fns";
// import { Helmet } from "react-helmet";
// import Loader from "./Utils/Loader";
// import Select from "react-select";
// import styled from "styled-components";

// export const Span = styled.span`
//   font-size: 13px;
//   color: #686868;
//   letter-spacing: 0.5px;
// `;
// const Star = styled.span`
//   color: #ff1237;
//   margin-left: 2px;
// `;
// function CarInquiry(props) {
//   const [loading, setLoading] = useState(true);
//   const [Companylist, setCompanylist] = useState([]);
//   const [vehicletypes, setVehicletypes] = useState([]);
//   const [Brandlist, setBrandlist] = useState([]);
//   const [Varientlist, setVarientlist] = useState([]);
//   const [Colorlist, setColorlist] = useState([]);
//   const [Fuelist, setFuelist] = useState([]);
//   const [Gearlist, setGearlist] = useState([]);
//   const [input, setInput] = useState({
//     stardate: DateFormate(new Date()),
//     enddate: DateFormate(new Date()),
//     gear: "",
//     owner: "",
//     seatingcapicity: "",
//     year: "",
//     km: "",
//     nInsurancetype: "Comprehensive",
//     color: "",
//     sunroof: "No",
//     cc: "",
//     nSaleprice: "",
//     nPurchaseprice: "",
//     vehicle: "",
//     priceTag: priceTagCmn[0].Value,
//   });
//   const [check, setCheck] = useState("Nill");
//   const [carstatus, setCarstatus] = useState("No");
//   const [src, setSrc] = useState("");
//   const [Features, setFeatures] = useState([]);
//   const [SelectedFeatures, setSelectedFeatures] = useState([]);
//   const [errors, setErrors] = useState({});
//   const selectRef = useRef({});
//   const navigate = useNavigate();
//   const nextMoveRef = useRef([]);

//   useEffect(() => {
//     let mounted = true;
//     let model;
//     if (Userlogin()) {
//       fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/companydata")
//         .then((response) => response.json())
//         .then((res) => {
//           if (mounted) {
//             setCompanylist(res.Data);
//           }
//         });
//       fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/Fueldata")
//         .then((response) => response.json())
//         .then((res) => {
//           if (mounted) {
//             setFuelist(res.Data);
//           }
//         });
//       fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/Geardata")
//         .then((response) => response.json())
//         .then((res) => {
//           if (mounted) {
//             setGearlist(res.Data);
//           }
//         });
//       fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/Vehiclenamedata")
//         .then((response) => response.json())
//         .then((res) => {
//           if (mounted) {
//             setVehicletypes(res.Data);
//           }
//         });

//       fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/Featuresdata")
//         .then((response) => response.json())
//         .then((res) => {
//           if (mounted) {
//             var option = [];
//             var obj;
//             res.Data.map((data) => {
//               obj = {
//                 label: data.Text,
//                 value: data.Value,
//               };
//               option.push(obj);
//               return option;
//             });
//             setFeatures(option);
//           }
//         });
//       // async function loadcoco(){
//       //   // eslint-disable-next-line no-undef
//       //    model=await cocoSsd.load();

//       // }
//       // loadcoco();
//       setLoading(false);
//     } else {
//       navigate("/Login");
//     }
//     return () => {
//       mounted = false;
//       if (model) {
//         model.dispose();
//       }
//     };
//   }, [navigate]);

//   // async function detectCar() {
//   //   const imageInput = document.getElementById("imageInput");
//   //   const resultDiv = document.getElementById("result");
//   //   // eslint-disable-next-line no-undef
//   //   const model = await cocoSsd.load();

//   //   if (!imageInput.files || !imageInput.files[0]) {
//   //     resultDiv.innerText = "No image uploaded";
//   //     return;
//   //   }

//   //   const imageFile = imageInput.files[0];
//   //   const imageURL = URL.createObjectURL(imageFile);

//   //   const image = new Image();
//   //   image.src = imageURL;

//   //   image.onload = async function () {
//   //     try {
//   //       // Load the COCO-SSD model

//   //       // Make predictions
//   //       const predictions = await model.detect(image);

//   //       // Check if a car is detected
//   //       const containsCar = predictions.some(
//   //         (prediction) => prediction.class === "car"
//   //       );

//   //       // Display result
//   //       if (containsCar) {
//   //         resultDiv.innerText = "Car detected";
//   //       } else {
//   //         resultDiv.innerText = "No car detected";
//   //       }
//   //     } catch (error) {
//   //       console.error("Error detecting car:", error);
//   //       resultDiv.innerText = "Error detecting car";
//   //     }
//   //   };
//   // }

//   const handleCompanychange = (obj) => {
//     fetch(
//       process.env.REACT_APP_API_ENDPOINT +
//         "/api/Common/activemodel/" +
//         obj.Value,
//     )
//       .then((response) => response.json())
//       .then((res) => {
//         setBrandlist(res.Data || []);
//         setVarientlist([]);
//         setColorlist([]);
//         setInput((prevInput) => ({
//           ...prevInput,
//           company: obj.Value,
//           Model: "",
//           color: "",
//           varient: "",
//         }));
//       });
//   };

//   const handleModalchange = (obj) => {
//     var details =
//       "companyid=" +
//       encodeURIComponent(input.company) +
//       "&Modelid=" +
//       encodeURIComponent(obj.Value);
//     const requestOptions = {
//       method: "POST",
//       mode: "cors",
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
//       },
//       body: details,
//     };
//     fetch(
//       process.env.REACT_APP_API_ENDPOINT + "/api/Common/veriantandcolour",
//       requestOptions,
//     )
//       .then((response) => response.json())
//       .then((res) => {
//         setVarientlist(res.Data.veriantdata || []);
//         setColorlist(res.Data.Colourdata || []);
//         setInput((prevInput) => ({
//           ...prevInput,
//           Model: obj,
//           varient: "",
//           color: "",
//         }));
//       });
//   };

//   const handlevarient = (obj) => {
//     setInput((prevInput) => ({
//       ...prevInput,
//       varient: obj.Value,
//       color: "",
//     }));
//   };
//   const handleChange = (e, index) => {
//     const isCarNumber = e.target.name === "carnumber";
//     // const isVarient = e.target.name === "varient";
//     // const isColor = e.target.name === "color";
//     let value = e.target.value;
//     setInput((prevInput) => ({
//       ...prevInput,
//       [e.target.name]: isCarNumber ? value.toUpperCase() : value,
//       // color: isVarient ? "" : isColor ? value : prevInput.color,
//     }));
//   };

//   const ondropdown = (opt) => {
//     setSelectedFeatures(opt);
//   };

//   const HandleNumerictextbox = (e) => {
//     var pattern = new RegExp(/^[0-9\b]+$/);
//     const { name, value } = e.target;
//     if (value === "" || pattern.test(value)) {
//       setInput((prevInput) => ({ ...prevInput, [name]: value }));
//     }
//   };

//   const HandleAmtInput = (e) => {
//     // only for rupees
//     const raw = e.target.value.replace(/[^0-9]/g, ""); // Remove non-digits
//     const { name } = e.target;
//     setInput((prevInput) => ({ ...prevInput, [name]: raw }));
//   };

//   const onDatechange = (value, name) => {
//     setInput((prevInput) => ({
//       ...prevInput,
//       [name]: DateFormate(value),
//     }));
//   };

//   const oncheck = (e) => {
//     const target = e.target;
//     setCheck(target.checked ? "Yes" : "Nill");
//   };

//   const onstatuscheck = (e) => {
//     const target = e.target;
//     setCarstatus(target.checked ? "Yes" : "No");
//   };

//   const Validate = () => {
//     let errors = {};
//     let isValid = true;

//     if (!input["vehicle"]) {
//       isValid = false;
//       errors["vehicle"] = "This feild is required";
//     }
//     if (!input["company"]) {
//       isValid = false;
//       errors["company"] = "This feild is required";
//     }
//     if (!input["Model"]) {
//       isValid = false;
//       errors["Model"] = "This feild is required";
//     }
//     if (!input["varient"]) {
//       isValid = false;
//       errors["varient"] = "This feild is required";
//     }
//     if (!input["color"]) {
//       isValid = false;
//       errors["color"] = "This feild is required";
//     }
//     if (!input["fuel"]) {
//       isValid = false;
//       errors["fuel"] = "This feild is required";
//     }
//     if (!input["carnumber"]) {
//       isValid = false;
//       errors["carnumber"] = "This feild is required.";
//     }
//     if (typeof input["carnumber"] !== "undefined") {
//       var pattern = new RegExp(process.env.REACT_APP_CARNO_PATTERN);
//       if (!pattern.test(input["carnumber"])) {
//         isValid = false;
//         errors["carnumber"] = "Enter valid vehicle number";
//       }
//       if (input["carnumber"].length > 11) {
//         isValid = false;
//         errors["carnumber"] = "Enter valid vehicle number";
//       }
//     }
//     if (!input["year"]) {
//       isValid = false;
//       errors["year"] = "This feild is  required";
//     }
//     if (typeof input["year"] !== undefined) {
//       if (input["year"].length > 4) {
//         isValid = false;
//         errors["year"] = "Enter valid Year";
//       }
//     }
//     // if (!input["km"]) {
//     //   isValid = false;
//     //   errors["km"] = "This feild is required";
//     // }
//     if (String(input["km"]).trim() !== "") {
//       if (input["km"].length > 6) {
//         isValid = false;
//         errors["km"] = "Enter valid kilometer";
//       }
//     }
//     if (!input["owner"]) {
//       isValid = false;
//       errors["owner"] = "This feild is required";
//     }
//     if (!input["seatingcapicity"]) {
//       isValid = false;
//       errors["seatingcapicity"] = "This feild is required";
//     }
//     if (typeof input["seatingcapicity"] !== undefined) {
//       if (Number(input["seatingcapicity"]) > 15) {
//         isValid = false;
//         errors["seatingcapicity"] = "Maximum seating capacity is 15";
//       }
//     }
//     if (!input["gear"]) {
//       isValid = false;
//       errors["gear"] = "This feild is required";
//     }
//     if (!input["cc"]) {
//       isValid = false;
//       errors["cc"] = "This feild is required";
//     }
//     if (input["cc"]) {
//       if (input["cc"].length > 4) {
//         isValid = false;
//         errors["cc"] = "Enter valid cubic capacity";
//       }
//     }
//     if (input["insurance"] === true) {
//       if (!input["enddate"]) {
//         isValid = false;
//         errors["enddate"] = "This feild  is required ";
//       }
//     }
//     if (!input["photo"]) {
//       isValid = false;
//       errors["photo"] = "Vehicle photo is required";
//     }

//     FocusonField(errors);
//     setErrors(errors);
//     return isValid;
//   };

//   const FocusonField = (errors) => {
//     if (Object.keys(errors).length > 0) {
//       // Scroll to the first error field
//       let errorElement;
//       const firstErrorField = Object.keys(errors)[0];
//       if (selectRef.current[firstErrorField]) {
//         errorElement = selectRef.current[firstErrorField].controlRef;
//       } else {
//         errorElement = document.getElementsByName(firstErrorField)[0];
//       }
//       // errorElement = selectRef.current.controlRef;

//       if (errorElement) {
//         errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
//         errorElement.focus();
//       }
//     }
//   };
//   const handleSubmit = () => {
//     if (Validate()) {
//       setLoading(true);
//       var param = {
//         carnumber: input.carnumber.trim(),
//         companyid: input.company,
//         carmodelid: input.Model.Value,
//         variantid: input.varient,
//         fueltypeid: input.fuel,
//         modelyear: input.year,
//         colour: input.color,
//         insurance: check,
//         insuranceendtdate: check === "Yes" ? input.enddate : "",
//         km: input.km.trim(),
//         owner: input.owner,
//         seatingcapicity: input.seatingcapicity.trim(),
//         Photoname: input.Photoname,
//         carphoto: input.photo,
//         gear: input.gear,
//         nInsurancetype: check === "Yes" ? input.nInsurancetype : "",
//         nSunRoof: input.sunroof,
//         nCc: input.cc.trim(),
//         nSaleprice: input.nSaleprice.trim(),
//         nPurchaseprice: input.nPurchaseprice.trim(),
//         nCaravaibility: carstatus,
//         vehicleid: input.vehicle,
//         nFeatures:
//           SelectedFeatures.length !== 0
//             ? SelectedFeatures.map((item) => item.value).join(",")
//             : "",
//         npricerate: input.priceTag,
//       };

//       var formBody = [];
//       for (var property in param) {
//         var encodedKey = encodeURIComponent(property);
//         var encodedValue = encodeURIComponent(param[property]);
//         formBody.push(encodedKey + "=" + encodedValue);
//       }
//       formBody = formBody.join("&");
//       const requestOptions = {
//         method: "POST",
//         mode: "cors",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
//           Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
//         },
//         body: formBody,
//       };
//       fetch(
//         process.env.REACT_APP_API_ENDPOINT + "/api/Carmaster/addcar",
//         requestOptions,
//       )
//         .then((response) => response.json())
//         .then(async (res) => {
//           setLoading(false);
//           if (res.Success === true) {
//             await PushpoptoCatalogue(input.carnumber, res.Data, "add");
//             navigate("/MyCar");
//             Toast(res.Success, "Vehicle added Successfully", res.Message);
//           } else {
//             Toast(res.Success, "", res.Message);
//           }
//         });
//     }
//   };

//   const handleCallback = (childData) => {
//     input["photo"] = childData.url.split(",")[1];
//     input["Photoname"] = childData.name;
//     setInput(input);
//     setSrc(childData.url);
//   };
//   // const selecteddate = (date) => {
//   //   const parsedDate = parse(date, "dd-MM-yyyy", new Date());
//   //   return parsedDate;
//   // };

//   const nextMoveFn = ({ value, index }) => {
//     // use: move next dropdodwn on select value of currenct dropdown
//     if (
//       String(value).length > 0 &&
//       index >= 0 &&
//       index < nextMoveRef.current.length - 1
//     ) {
//       let nextElm = nextMoveRef.current[index + 1];
//       if (!nextElm) return;

//       nextElm.focus();

//       let eleRef = nextElm.controlRef ?? nextElm; // controlRef for react-select dropdown

//       eleRef.scrollIntoView({
//         behavior: "smooth",
//         block: "center", // Ensures it's visible in the viewport
//         inline: "nearest",
//       });
//     }
//   };

//   return (
//     <div>
//       <Header />
//       {loading ? <Loader /> : null}

//       {/* <input type="file" accept="image/*" id="imageInput" />
//       <button onClick={(e) => detectCar()}>Detect Car</button>
//       <div id="result"></div> */}

//       <div className="content">
//         <div className="text-center">
//           <h2 className="page-title">Add Car</h2>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Vehicle Type<Star>*</Star>
//           </label>
//           <select
//             className="form-select form-control"
//             name="vehicle"
//             ref={(el) => (nextMoveRef.current[0] = el)}
//             value={input.vehicle}
//             onChange={(e) => {
//               handleChange(e);
//               nextMoveFn({ value: e.target.value, index: 0 });
//             }}
//           >
//             <option value="" disable="disable">
//               --Select vehicle Type--
//             </option>
//             {vehicletypes.map((list) => (
//               <option value={list.Value} key={list.Value}>
//                 {list.Text}
//               </option>
//             ))}
//           </select>

//           <span className="text-danger">{errors.vehicle}</span>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Company<Star>*</Star>
//           </label>
//           <Select
//             ref={(el) => {
//               if (el) {
//                 selectRef.current.company = el;
//                 nextMoveRef.current[1] = el; // for move next on select automatically
//               }
//             }}
//             placeholder="--Select Company--"
//             name="company"
//             options={Companylist}
//             // value={}
//             getOptionLabel={(option) => option.Text}
//             getOptionValue={(option) => option.Value}
//             onChange={(e) => {
//               handleCompanychange(e);

//               nextMoveFn({ value: e.Value, index: 1 });
//             }}
//             closeMenuOnSelect={true}
//             blurInputOnSelect={false}
//             isSearchable={true}
//             styles={customStyles}
//           ></Select>

//           <span className="text-danger">{errors.company}</span>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Model<Star>*</Star>
//           </label>
//           <Select
//             placeholder="--Select Model--"
//             value={input.Model}
//             name="Model"
//             ref={(el) => {
//               if (el) {
//                 selectRef.current.Model = el;
//                 nextMoveRef.current[2] = el;
//               }
//             }}
//             options={Brandlist}
//             getOptionLabel={(option) => option.Text}
//             getOptionValue={(option) => option.Value}
//             onChange={(e) => {
//               handleModalchange(e);

//               nextMoveFn({ value: e.Value, index: 2 });
//             }}
//             closeMenuOnSelect={true}
//             blurInputOnSelect={false}
//             isSearchable={true}
//             styles={customStyles}
//           ></Select>
//           <span className="text-danger">{errors.Model}</span>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Varient<Star>*</Star>
//           </label>
//           <Select
//             placeholder="--Select Varient--"
//             name="varient"
//             // value={}
//             ref={(el) => {
//               if (el) {
//                 selectRef.current.varient = el;
//                 nextMoveRef.current[3] = el;
//               }
//             }}
//             options={Varientlist}
//             getOptionLabel={(option) => option.Text}
//             getOptionValue={(option) => option.Value}
//             onChange={(e) => {
//               handlevarient(e);

//               nextMoveFn({ value: e.Value, index: 3 });
//             }}
//             closeMenuOnSelect={true}
//             blurInputOnSelect={false}
//             isSearchable={true}
//             styles={customStyles}
//           ></Select>
//           <span className="text-danger">{errors.varient}</span>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Color<Star>*</Star>
//           </label>
//           <select
//             className="form-select form-control"
//             ref={(el) => {
//               if (el) {
//                 nextMoveRef.current[4] = el;
//               }
//             }}
//             name="color"
//             value={input.color}
//             onChange={(e) => {
//               handleChange(e);

//               nextMoveFn({ value: e.target.value, index: 4 });
//             }}
//           >
//             <option value="" disable="disable">
//               --Select Color--
//             </option>
//             {Colorlist.map((list) => (
//               <option value={list.Value} key={list.Value}>
//                 {list.Text}
//               </option>
//             ))}
//           </select>

//           <span className="text-danger">{errors.color}</span>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Fuel<Star>*</Star>
//           </label>
//           <select
//             className="form-select form-control"
//             name="fuel"
//             ref={(el) => {
//               if (el) {
//                 nextMoveRef.current[5] = el;
//               }
//             }}
//             defaultValue=""
//             onChange={(e) => {
//               handleChange(e);

//               nextMoveFn({ value: e.target.value, index: 5 });
//             }}
//           >
//             <option value="" disable="disable">
//               --Select Fuel--
//             </option>
//             {Fuelist.map((list) => (
//               <option value={list.Value} key={list.Value}>
//                 {list.Text}
//               </option>
//             ))}
//           </select>

//           <span className="text-danger">{errors.fuel}</span>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Vehicle number<Star>*</Star> <Span>(Ex. GJ01HQ9999)</Span>
//           </label>
//           <input
//             type="text"
//             className="form-control"
//             name="carnumber"
//             id="carnumber"
//             value={input.carnumber}
//             onChange={handleChange}
//             ref={(el) => {
//               if (el) {
//                 nextMoveRef.current[6] = el;
//               }
//             }}
//           />
//           <span className="text-danger">{errors.carnumber}</span>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Year<Star>*</Star>
//           </label>
//           <input
//             type="number"
//             className="form-control"
//             name="year"
//             value={input.year}
//             maxLength="4"
//             onChange={HandleNumerictextbox}
//           />
//           <span className="text-danger">{errors.year}</span>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Kilometer
//             {/* Kilometer<Star>*</Star> */}
//           </label>
//           <input
//             type="tel"
//             className="form-control"
//             name="km"
//             // maxLength="7"
//             // value={input.km}
//             value={input.km ? Intl.NumberFormat("en-IN").format(input.km) : ""}
//             // onChange={HandleNumerictextbox}
//             onChange={HandleAmtInput}
//           />
//           <span className="text-danger">{errors.km}</span>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Vehicle owner<Star>*</Star>
//           </label>
//           <select
//             className="form-select form-control"
//             name="owner"
//             defaultValue=""
//             onChange={handleChange}
//           >
//             <option value="" disable="disable">
//               --Select owner--
//             </option>
//             {ownerDrop.map((list) => (
//               <option value={list.Value} key={list.Value}>
//                 {list.Text}
//               </option>
//             ))}
//           </select>

//           <span className="text-danger">{errors.owner}</span>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Seating capacity<Star>*</Star>
//           </label>
//           <input
//             type="number"
//             className="form-control"
//             name="seatingcapicity"
//             max="2"
//             value={input.seatingcapicity}
//             onChange={HandleNumerictextbox}
//           />
//           <span className="text-danger">{errors.seatingcapicity}</span>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Gear<Star>*</Star>
//           </label>
//           <select
//             className="form-select form-control"
//             name="gear"
//             defaultValue=""
//             ref={(el) => {
//               if (el) {
//                 nextMoveRef.current[7] = el;
//               }
//             }}
//             onChange={(e) => {
//               handleChange(e);

//               nextMoveFn({ value: e.target.value, index: 7 });
//             }}
//           >
//             <option value="" disable="disable">
//               --Select Gear--
//             </option>
//             {Gearlist.map((list) => (
//               <option value={list.Value} key={list.Value}>
//                 {list.Text}
//               </option>
//             ))}
//           </select>

//           <span className="text-danger">{errors.gear}</span>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Sunroof<Star>*</Star>
//           </label>
//           <select
//             className="form-select form-control"
//             name="sunroof"
//             defaultValue="No"
//             ref={(el) => {
//               if (el) {
//                 nextMoveRef.current[8] = el;
//               }
//             }}
//             onChange={(e) => {
//               handleChange(e);

//               nextMoveFn({ value: e.target.value, index: 8 });
//             }}
//           >
//             <option value="Yes">Yes</option>
//             <option value="No">No</option>
//           </select>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Choose a vehicle feature <Span>(optional)</Span>
//           </label>
//           <Select
//             ref={(el) => {
//               if (el) {
//                 nextMoveRef.current[9] = el;
//               }
//             }}
//             isMulti
//             name="feature"
//             options={Features}
//             onChange={ondropdown}
//             closeMenuOnSelect={false}
//             blurInputOnSelect={false}
//             isSearchable={false}
//             styles={customStyles}
//           ></Select>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Cubic capacity<Star>*</Star> <Span>(Ex. 1.6)</Span>
//           </label>
//           <input
//             type="number"
//             step="0.01"
//             className="form-control"
//             name="cc"
//             value={input.cc}
//             maxLength="4"
//             onChange={handleChange}
//           />
//           <span className="text-danger">{errors.cc}</span>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Sale price for salesman <Span>(optional)</Span>
//           </label>
//           <input
//             type="tel"
//             className="form-control"
//             name="nPurchaseprice"
//             // value={input.nPurchaseprice}
//             value={
//               input.nPurchaseprice
//                 ? Intl.NumberFormat("en-IN").format(input.nPurchaseprice)
//                 : ""
//             }
//             maxLength="13" // 10 digit with comma
//             onChange={HandleAmtInput}
//           />
//           <span className="text-danger">{errors.nPurchaseprice}</span>
//         </div>

//         <div className="form-div">
//           <label className="form-label">
//             Sale price for customer <Span>(optional)</Span>
//           </label>
//           <input
//             type="tel"
//             className="form-control"
//             name="nSaleprice"
//             // value={input.nSaleprice}
//             value={
//               input.nSaleprice
//                 ? Intl.NumberFormat("en-IN").format(input.nSaleprice)
//                 : ""
//             }
//             maxLength="13" // 10 digit with comma
//             onChange={HandleAmtInput}
//           />
//           <span className="text-danger">{errors.nSaleprice}</span>
//         </div>

//         {/* new added */}
//         <div className="form-div">
//           <label className="form-label">Price Tag</label>
//           <select
//             className="form-select form-control"
//             name="priceTag"
//             onChange={(e) => {
//               handleChange(e);
//             }}
//             value={input?.priceTag}
//           >
//             <option value="" disabled>
//               --Select Price Tag--
//             </option>
//             {priceTagCmn.map((list) => (
//               <option value={list.Value} key={list.Value}>
//                 {list.Text}
//               </option>
//             ))}
//           </select>
//         </div>
//         {/* new added end */}
//         <div className="form-check-inline form-div">
//           <input
//             type="checkbox"
//             className="form-check-input"
//             id="check2"
//             name="carstatus"
//             onChange={onstatuscheck}
//           />
//           <label className="form-label ms-1" htmlFor="check2">
//             Coming soon
//             <div>
//               <Span> (Check to create status- as 'Coming Soon')</Span>
//             </div>
//           </label>
//         </div>
//         <div>
//           <div className="form-check-inline form-div">
//             <input
//               type="checkbox"
//               className="form-check-input"
//               id="check1"
//               name="insurance"
//               onChange={oncheck}
//             />
//             <label className="form-label ms-1" htmlFor="check1">
//               Insurance
//             </label>
//           </div>
//           {check === "Yes" ? (
//             <div>
//               <div className="text-center">
//                 <div className="form-check-inline">
//                   <input
//                     type="radio"
//                     className="form-check-input"
//                     id="radio1"
//                     name="nInsurancetype"
//                     value="Comprehensive"
//                     defaultChecked={
//                       input.nInsurancetype === "Comprehensive" ? true : false
//                     }
//                     onChange={handleChange}
//                   />
//                   <label className="form-check-label ps-1" htmlFor="radio1">
//                     Comprehensive
//                   </label>
//                 </div>
//                 <div className="form-check-inline">
//                   <input
//                     type="radio"
//                     className="form-check-input"
//                     id="radio2"
//                     name="nInsurancetype"
//                     value="Third Party"
//                     defaultChecked={
//                       input.nInsurancetype === "Third Party" ? true : false
//                     }
//                     onChange={handleChange}
//                   />
//                   <label className="form-check-label ps-1" htmlFor="radio2">
//                     Third Party
//                   </label>
//                 </div>
//                 <div className="form-check-inline">
//                   <input
//                     type="radio"
//                     className="form-check-input"
//                     id="radio3"
//                     name="nInsurancetype"
//                     value="Zero depth"
//                     defaultChecked={
//                       input.nInsurancetype === "Zero depth" ? true : false
//                     }
//                     onChange={handleChange}
//                   />
//                   <label className="form-check-label ps-1" htmlFor="radio3">
//                     Zero depth
//                   </label>
//                 </div>
//               </div>
//               {/* <div className="form-div">
//                 <label className="form-label">Insurance Start Date</label>

//                 <DatePicker
//                   defaultValue={new Date()}
//                   valueFormat={{ dateStyle: "medium" }}
//                   name="stardate"
//                   onChange={(e) => onDatechange(e, "stardate")}
//                   onKeyDown={(e) => e.preventDefault()}
//                 />

//                 <span className="text-danger">{errors.stardate}</span>
//               </div> */}
//               <div className="form-div">
//                 <label className="form-label">Insurance End Date</label>
//                 <DatePicker
//                   defaultValue={new Date()}
//                   valueFormat={{ dateStyle: "medium" }}
//                   name="enddate"
//                   onChange={(e) => onDatechange(e, "enddate")}
//                   onKeyDown={(e) => e.preventDefault()}
//                   inputProps={{ readOnly: true }}
//                 />
//                 <span className="text-danger">{errors.enddate}</span>
//               </div>
//             </div>
//           ) : null}
//         </div>
//         <div className="form-div">
//           <div className="mb-2 mx-1">
//             <span style={{ fontWeight: "500", color: "#ff1237" }}>Note :</span>
//             <span className="title" style={{ color: "#ff1237" }}>
//               &nbsp; Only one front photo of vehicle can be added from here. HD
//               and .HEIC photos are not allowed.
//             </span>
//           </div>
//           <Upload_photo parentCallback={handleCallback} />

//           <span className="text-danger">{errors.photo}</span>
//           <div className="col-12 text-center pt-2">
//             {src ? (
//               <img src={src} style={{ maxWidth: "200px" }} alt="" />
//             ) : (
//               <>
//                 <span className="title" style={{ color: "#ff1237" }}>
//                   For example :
//                 </span>
//                 <br />
//                 <img
//                   src="/assets/images/add-vehicle-sample.jpg"
//                   style={{ maxWidth: "200px" }}
//                   alt=""
//                 />
//               </>
//             )}
//           </div>
//         </div>

//         <div className="text-center pt-3">
//           <button type="submit" className="submitbtn" onClick={handleSubmit}>
//             Submit
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default CarInquiry;
